import BrandItems from "./BrandItems/BrandItems"
import ItemDetails from "./ItemDetails/ItemDetails"

export default { BrandItems, ItemDetails }
